document.addEventListener("DOMContentLoaded", function () {
    const open_btn = document.querySelector('[data-js-async-drawer-open]')

    if(!open_btn){
        return console.log("Cant find open button for async slider")
    }

    const overlay = document.querySelector('.async-slider__container .overlay')
    const content = document.querySelector('.content__container')
    const async_container = document.querySelector('[data-js-async-content]')

    /* open actions */
    open_btn.addEventListener('click', async ()=>{
        console.log('Open slider')

        console.log({overlay})

        overlay.classList.toggle('open')
        content.classList.toggle('open')

    })

    /* Close actions */
    const close_btns = document.querySelectorAll('[data-js-async-drawer-close]')

    close_btns.forEach(btn => btn.addEventListener('click', removeOpenStyles(btn)))
    
    overlay.addEventListener('click', async ()=>{
        overlay.classList.remove('open')
        content.classList.remove('open')
    })

    /* utils */
    function removeOpenStyles(el){
        el.addEventListener('click', ()=>{
            overlay.classList.remove('open')
            content.classList.remove('open')
        })      
    }

    async function getPageData(){
        try {
            const req = await fetch('/pages/cane-sizing-product-drawer')
            if(!req.ok){
                return null
            }
            const data = await req.text()
            return data
        } catch (error) {
            console.log("Failed fetch async drawer page content")
            return null
        }

    }

})